export const FETCH_DOCUMENTS_VERSION_REQUEST = 'FETCH_DOCUMENTS_VERSION_REQUEST'
export const FETCH_DOCUMENTS_VERSION_SUCCESS = 'FETCH_DOCUMENTS_VERSION_SUCCESS'
export const FETCH_DOCUMENTS_VERSION_FALUIRE = 'FETCH_DOCUMENTS_VERSION_FALUIRE'
